<template>
    <v-row justify="end" align="end" class="ma-n1 flex-nowrap" :class="{ 'mt-n2': isItemSequent }">
        <v-col cols="auto" class="pa-1" :style="{ opacity: isTimeSequent ? 0 : 1 }">
            <span class="text-caption ml-1">{{ time }}</span>
        </v-col>
        <v-col cols="auto" class="pa-1" style="max-width: calc(100% - 36px)">
            <v-card color="primary lighten-5" flat min-height="36">
                <v-card-text class="py-2 px-3 text-caption">
                    {{ message?.content }}
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";
import { CHAT_MESSAGE_TYPES, initChatMessage } from "@/store/chat";

export default {
    props: {
        messages: { type: Array, default: () => [] },

        index: { type: Number, default: 0 },
        message: { type: Object, default: initChatMessage },
    },
    computed: {
        time() {
            return dayjs(this.message?.createdAt).format("HH:mm");
        },
        isItemSequent() {
            if (this.index == 0) return false;
            const prev = this.messages[this.index - 1];
            return prev?.type == CHAT_MESSAGE_TYPES.PROMPT_QUERY.value;
        },
        isTimeSequent() {
            if (this.index == this.messages.length - 1) return false;

            const next = this.messages[this.index + 1];
            if (next?.type != CHAT_MESSAGE_TYPES.PROMPT_QUERY.value) return false;

            return dayjs(next?.createdAt).format("HH:mm") == this.time;
        },
    },
};
</script>

<style></style>
